import { ENTITY_MODAL_TYPES, type ModalEntityKey } from './entity-modal.constants';
import { ENTITY_ICONS } from './EntityModalComponents';
import { useTranslation } from 'react-i18next';

interface TypeSelectorProps {
  onSelect: (type: ModalEntityKey) => void;
}

export function TypeSelector({ onSelect }: TypeSelectorProps) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-3 gap-2.5">
      {(
        Object.entries(ENTITY_MODAL_TYPES) as [
          ModalEntityKey,
          (typeof ENTITY_MODAL_TYPES)[ModalEntityKey],
        ][]
      ).map(([key, config]) => {
        const Icon = ENTITY_ICONS[key];
        return (
          <button
            key={key}
            type="button"
            onClick={() => onSelect(key)}
            className="flex flex-col items-center gap-2.5 p-5 rounded-xl cursor-pointer transition-all duration-200 hover:-translate-y-0.5"
            style={{
              backgroundColor: config.accentSoft,
              border: `1px solid ${config.accentBorder}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = config.accent;
              e.currentTarget.style.boxShadow = `0 8px 24px ${config.accentSoft}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = config.accentBorder;
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div
              className="w-11 h-11 rounded-xl flex items-center justify-center"
              style={{
                background: `linear-gradient(135deg, ${config.accentSoft}, ${config.accentBorder})`,
                color: config.accent,
              }}
            >
              <Icon size={24} />
            </div>
            <div className="text-center">
              <div className="text-[13px] font-semibold text-zinc-200">{t(config.label)}</div>
              <div className="text-[10.5px] text-zinc-500 mt-0.5 leading-snug">
                {t(config.desc)}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
